const defaults = {
    footerProps: {
        disableItemsPerPage: true,
        itemsPerPageOptions: [-1]
    }
}

export default defaults;